<template>
    <div class="col margin-bottom-50 thanks">
        <div class="row">
            <div class="thanks_content clearfix w-100">
                <div class="title">
                    <h3>{{ site.name }}</h3>
                </div>
                <section class="col-sm-12 q">
                    <section class="vraag w100 clearfix">
                        <p>{{ genderTranslation }} {{ contact.first_letters ? contact.first_letters + ' ': '' }}{{ contact.middle_name ? contact.middle_name + ' ': ''}}{{ contact.last_name }},</p>

                        <p>{{ $t('default.MessageReceived')}}</p>

                        <p>{{ $t('default.Important')}}</p>

                        <p><strong>{{ $t('default.YouFilledIn')}}</strong></p>

                        <table width="100%" cellpadding="2" cellspacing="2" border="0">

                            <tr>
                                <td>{{ $t('default.Nameproduct') }}</td>
                                <td>{{ contact.name_product }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Packsize') }}</td>
                                <td>{{ contact.size_package }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Lotnr') }}</td>
                                <td>{{ contact.lot_number }}</td>
                            </tr>


                            <tr v-if="block.expanded">
                                <td>{{ $t('default.HasThePackaging') }}</td>
                                <td>{{ yesNoTranslation('has_package') }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.HasTheProduct') }}</td>
                                <td>{{ yesNoTranslation('has_product') }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Whatisyourcomplaint') }}</td>
                                <td>{{ complaints }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.DescriptionOfYourComplaint') }}</td>
                                <td>{{ contact.description_complaint }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Firstletters') }}</td>
                                <td>{{ contact.first_letters }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Firstname') }}</td>
                                <td>{{ contact.first_name }} </td>
                            </tr>


                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Middlename') }}</td>
                                <td>{{ contact.middle_name }}</td>
                            </tr>


                            <tr>
                                <td>{{ $t('default.Lastname') }}</td>
                                <td>{{ contact.last_name }}</td>
                            </tr>


                            <tr v-if="block.show_year_of_birth">
                                <td>{{ $t('default.Yearofbirth') }}</td>
                                <td>{{ contact.year_of_birth }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Email') }}</td>
                                <td>{{ contact.email }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Phone') }}</td>
                                <td>{{ contact.phone }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Address') }}</td>
                                <td>{{ contact.street}}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Zipcode') }}</td>
                                <td>{{ contact.zip_code }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.City') }}</td>
                                <td>{{ contact.city }}</td>
                            </tr>
                        </table>
                    </section>

                      <div class="clear"></div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import Block from "@/mixins/Block.js"
    import GenderTranslation from '@/mixins/GenderTranslation.js'

    export default {
        props: ['contact'],
        mixins: [Block, GenderTranslation],
        computed: {
            complaints() {
                let stringComplaints = "";

                if (this.contact.complaints === null) {

                    return stringComplaints;
                }

                this.contact.complaints.forEach(complaint => {
                    stringComplaints += this.$t('default.' + complaint) + ", ";
                });

                return this.rtrim(stringComplaints, ", ");
            }
        },
        methods: {
            yesNoTranslation(field) {

                return (Number(this.contact[field]) == 1 ? this.$t('default.Yes') : this.$t('default.No'));
            },
            rtrim(str, s) {
                return str.replace(new RegExp(s + "*$"),'');
            }
        }
    }
</script>